export type BookingState = {
  booking: {
    salon: {
      pet: {
        uid?: string;
        additionalRace: Record<string, any>;
        castrated: string;
        dateOfBirth: string;
        gender: string;
        lifePhase: string;
        matted: string;
        coatLength: any;
        name: string;
        petType: string;
        race: Record<string, any>;
        size: string;
        visit: string;
      };
      salon: Record<string, any>;
      selectedPackage?: {
        title: string;
        description: string;
        price: string;
        priceType: string;
        package: string;
        packageDetails: string;
      };
      date: string;
      time: {
        slotStartTime?: string;
        resourceIds?: Array<any>;
      };
      message: string;
      images: any[];
    };
  };
};

export const useBookingStore = defineStore('booking', {
  state: (): BookingState => ({
    booking: {
      salon: {
        pet: {
          additionalRace: {},
          castrated: '',
          dateOfBirth: '',
          gender: '',
          lifePhase: '',
          matted: '',
          coatLength: undefined,
          name: '',
          petType: '',
          race: {},
          size: '',
          visit: '',
        },
        salon: {},
        selectedPackage: undefined,
        time: {},
        date: '',
        images: [],
        message: '',
      },
    },
  }),
  actions: {
    setSalon(salon: any) {
      this.booking.salon.salon = salon;
    },
    setPet(pet: any) {
      this.booking.salon.pet = pet;
    },
    setSelectedPackage(selectedPackage: BookingState['booking']['salon']['selectedPackage']) {
      this.booking.salon.selectedPackage = selectedPackage;
    },
    setBookingDate(date: string) {
      this.booking.salon.date = date;
    },
    setBookingTime(time: BookingState['booking']['salon']['time']) {
      this.booking.salon.time = time;
    },
    setBookingImages(images: Array<any>) {
      this.booking.salon.images = images;
    },
    setBookingMessage(message: string) {
      this.booking.salon.message = message;
    },
  },
  getters: {
    getSalon(state) {
      return state.booking.salon.salon;
    },
    getPet(state) {
      return state.booking.salon.pet;
    },
    getSelectedPackage(state) {
      return state.booking.salon.selectedPackage;
    },
    getBooking(state) {
      return state.booking;
    },
    getIsSmallPet(state) {
      return (
        state.booking.salon.pet?.petType.toUpperCase() === PET_TYPE_CAT ||
        state.booking.salon.pet?.lifePhase === PET_TYPE_PUPPY
      );
    },
    getIsNewFlow() {
      const { baseStoreDe } = useRuntimeConfig().public;
      const { baseStore, getSalonPriceItemsNewEnabled } = useMainStore();
      return baseStore === baseStoreDe && getSalonPriceItemsNewEnabled;
    },
    getCurrentFlow(): Array<string> {
      return this.getIsNewFlow ? FLOW_DE : FLOW_DEFAULT;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBookingStore, import.meta.hot));
}
